export default __webpack_public_path__ + "static/media/banner-simulador.813353cb.jpeg";